import { render, staticRenderFns } from "./AllocationPeriods.vue?vue&type=template&id=b9949764"
import script from "./AllocationPeriods.vue?vue&type=script&lang=ts"
export * from "./AllocationPeriods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports